import Flickity from 'flickity';
import { forEach } from 'lodash';

export default class Map {
  constructor(root) {
    this.root = root;
    this.current = 0;
    this.list = this.root.querySelector('.u-map__list');

    this.buttons = this.root.querySelectorAll('.u-map__list li');
    this.contents = this.root.querySelectorAll('[data-map-content]');
    this.mapEurope = this.root.querySelector('.u-map__image__europe');
    this.mapBelgium = this.root.querySelector('.u-map__image__belgium');
    this.mapLabels = this.root.querySelectorAll('.u-map__image [data-map-label]');

    if (!this.list) {
      return;
    }

    this.bind();
  }

  bind() {
    this.onSelect = this.onSelect.bind(this);
    this.onLabelClick = this.onLabelClick.bind(this);

    this.flkty = new Flickity(this.list, {
      prevNextButtons: true,
      pageDots: false,
      arrowShape: `M4.8,43.2C1.6,46.4,1.1,51.3,3.4,55c0.4,0.6,0.8,1.2,1.4,1.8l36.4,36.4C45,97,51,97,54.8,93.2c3.8-3.7,3.7-9.8,0-13.6
      l-20-20l53.6,0c5.3,0,9.6-4.3,9.6-9.6c0-5.3-4.3-9.6-9.6-9.6H34.8l20-20l0,0c3.7-3.7,3.8-9.8,0-13.6C51,3.1,45,3.1,41.2,6.8
      c0,0,0,0-0.1,0.1L4.8,43.2C4.9,43.2,4.8,43.2,4.8,43.2`,
      watchCSS: true,
      initialIndex: this.current
    });

    forEach(this.buttons, (button, index) => {
      button.addEventListener('click', e => {
        e.preventDefault();

        if (!this.flkty.isActive) {
          this.setCurrent(index);
        }
      });
    });

    forEach(this.mapLabels, button => {
      button.addEventListener('click', this.onLabelClick);
    });

    this.flkty.on('select', this.onSelect);
  }

  onLabelClick(e) {
    e.preventDefault();
    const id = +e.currentTarget.dataset.mapLabel;

    if (!id) {
      return;
    }

    // if (!this.flkty.isActive) {
    this.setCurrent(id);
    // }
  }

  onSelect(e) {
    const newIndex = this.flkty.selectedIndex;

    if (newIndex !== this.current) {
      this.setCurrent(newIndex);
    }
  }

  setCurrent(index) {
    if (index == this.current) {
      return;
    }

    console.log('setCurrent ', index);
    this.current = index;
    this.flkty.select(index);

    this.clearButtons();
    this.clearContents();
    this.clearLabels();

    this.buttons[index].classList.add('active');
    this.contents[index].classList.add('active');

    const newLabel = this.root.querySelector(`.u-map__image [data-map-label="${index}"]`);

    if (newLabel) {
      // newLabel.classList.add('active');
      newLabel.setAttribute('class', 'active');
    }

    if (index > 0) {
      this.mapEurope.classList.remove('active');
      this.mapBelgium.classList.add('active');
    } else {
      this.mapEurope.classList.add('active');
      this.mapBelgium.classList.remove('active');
    }
  }

  clearButtons() {
    forEach(this.buttons, content => {
      content.classList.remove('active');
    });
  }

  clearContents() {
    forEach(this.contents, content => {
      content.classList.remove('active');
    });
  }

  clearLabels() {
    forEach(this.mapLabels, label => {
      // label.classList.remove('active');
      label.setAttribute('class', '');
    });
  }
}